<nav class="navbar navbar-expand-lg navbar-light bg-white">
  <div class="container-fluid">
    <a class="navbar-brand mx-3" href="#">{{ title }}</a>
    <div class="navbar-nav ms-auto">
<!--      <a class="nav-link" href="/login">Login</a>-->
    </div>
  </div>
</nav>
